module.exports = __webpack_public_path__ + "static/img/4020_phase_function_Paper_PointsHejduk_Prediction.954d5ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4020_phase_function_Paper_PointsHejduk_Prediction.png
// module id = TRU3
// module chunks = 0